<template>
  <div class="animated fadeIn">
    <Tables ref="tableGrid"
            :columns="['Data Incial', 'Data Final', 'Valor', $lang.Common.DataTable.Actions]"
            :showNew="true"
            :showReload="true"
            :showTipFooter="false"
            v-on:New="onNew"
            v-on:Load="onLoad"
            v-on:Reload="onLoad">
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <TableColumn :IsText="true" v-on:Edit="onEdit(obj)" :status="obj.inative ? 0 : 1" :value="obj.dataInicial ? formatData(obj.dataInicial) : ''" />
        <TableColumn :IsText="true" v-on:Edit="onEdit(obj)" :status="obj.inative ? 0 : 1" :value="obj.dataFinal ? formatData(obj.dataFinal) : ''" />
        <TableColumn :IsText="true" v-on:Edit="onEdit(obj)" :status="obj.inative ? 0 : 1" :value="obj.valor ? formatValor(obj.valor) : ''" />
        <TableColumn :IsActionsButtons="true" :HasChange="false" v-on:Delete="onDelete(obj)" :status="obj.status" />
      </tr>
    </Tables>
    <div class="row">
      <div class="col-12 pb-3 pl-4">
        <button type="button" class="btn btn-third btn-sm" v-on:click="$emit('New')" v-b-tooltip.hover :title="'Clique para cadastrar'">
          <i class="fas fa-user-plus"></i> <span class="d-md-down-none">&nbsp; Novo</span>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'

import KmValueRepository from '@/shared/http/repositories/configurations/kmvalue.js'
import KmValueSearchScreen from '../search/search.vue'

export default {
  name: 'kmValueList',
  mixins: [ActionsForm],
  data () {
    return {
      filters: null,
      data: null,
      form: null
    }
  },
  methods: {
    onLoad () {
      this.onLoadAll()
      this.$eventHub.on('Filter', ({ filters }) => {
        this.filters = filters
        this.$refs.tableGrid.Clear()
        this.$nextTick(() => {
          this.onLoadAll()
        })
      })
    },
    onLoadAll () {
      loading.push()
      if (this.filters) {
        KmValueRepository.Search(this.filters.data, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
          .then((response) => {
            this.onResultGrid(response)
          })
          .catch((err) => {
            this.onException(err)
          })
      } else {
        KmValueRepository.GetAllPaging(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
          .then((response) => {
            this.onResultGrid(response)
          })
          .catch((err) => {
            this.onException(err)
          })
      }
    },
    onNew () {
      this.$emit('New')
    },
    onEdit (obj) {
      this.$emit('Edit', obj)
    },
    onDelete (obj) {
      loading.push()
      KmValueRepository.Delete(obj.id)
        .then(this.onResult)
        .catch(this.onException)
    },
    onShowSearch () {
      let aside = {
        title: 'Pesquisar',
        self: this,
        component: KmValueSearchScreen
      }
      this.$eventHub.emit('Search', aside)
    },
    formatData (data) {
      return this.moment(new Date(data)).tz('UTC').format('DD/MM/YYYY')
    },
    formatValor (valor) {
      return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valor)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/kmValue/components/list/kmValueList.vue